export const getMaxDate = (ageRange) => {
  const today = new Date();
  const maxDate =
    ageRange === 1
      ? today
      : new Date(
          today.getFullYear() - ageRange,
          today.getMonth(),
          today.getDate()
        );
  return maxDate;
};
export const getMinDate = (ageRange) => {
  const today = new Date();
  const minDate = new Date(today.getFullYear() - ageRange, 0, 1);
  return minDate;
};

export const convertUTCRangeToLocal = (range) => {
  if (!range || range.length !== 2) return [null, null];

  const [start, end] = range;

  const toLocal = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  };

  return [toLocal(start), toLocal(end)];
};

export const convertLocalRangeToUTC = (range) => {
  if (!range || range.length !== 2) return [null, null];

  const [start, end] = range;

  const toUTC = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  };

  return [toUTC(start), toUTC(end)];
};
